import { type ComponentProps, forwardRef, useMemo } from 'react';
import { ScrollView, type ViewStyle } from 'react-native';

import { theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const ScrollspyV2Nav = forwardRef<ScrollView, ScrollspyV2NavProps>((props, ref) => {
  const {
    children,
    gap = theme.spacing['1'],
    stagePadding,
    contentContainerStyle,
    ...restProps
  } = props;

  // ─── Styles ────────────────────────────────────────────────────────────

  const dynamicStyles = useMemo<ViewStyle>(
    () => ({
      columnGap: gap,
      paddingHorizontal: stagePadding,
    }),
    [gap, stagePadding],
  );
  const contentContainerStyles = [dynamicStyles, contentContainerStyle];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <ScrollView
      ref={ref}
      showsHorizontalScrollIndicator={false}
      horizontal
      contentContainerStyle={contentContainerStyles}
      scrollEventThrottle={16}
      {...restProps}
    >
      {children}
    </ScrollView>
  );
});

ScrollspyV2Nav.displayName = 'ScrollspyV2Nav';

// ─── Types ───────────────────────────────────────────────────────────────────

type ScrollspyV2NavProps = {
  gap?: ViewStyle['gap'];
  stagePadding?: number;
} & Omit<ComponentProps<typeof ScrollView>, 'horizontal'>;
